// SEO configuration for the website
export const DEFAULT_SEO = {
  titleTemplate: '%s | 10-Finger-Schreiben-Lernen.de',
  defaultTitle: '10-Finger-Schreiben lernen | Der kostenlose Online-Kurs',
  description: 'Lerne schnell und effizient das 10-Finger-System mit unserem kostenlosen Online-Kurs. Verbessere deine Tippgeschwindigkeit und reduziere Fehler.',
  canonical: 'https://10-finger-schreiben-lernen.de',
  openGraph: {
    type: 'website',
    locale: 'de_DE',
    url: 'https://10-finger-schreiben-lernen.de',
    siteName: '10-Finger-Schreiben-Lernen.de',
    images: [
      {
        url: 'https://10-finger-schreiben-lernen.de/images/logo.png',
        width: 1200,
        height: 630,
        alt: '10-Finger-Schreiben lernen',
      },
    ],
  },
  twitter: {
    handle: '@10fingerschreiben',
    site: '@10fingerschreiben',
    cardType: 'summary_large_image',
  },
  additionalMetaTags: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    },
    {
      name: 'keywords',
      content: '10-Finger-System, Tippen lernen, Schreibmaschinenkurs, Tippgeschwindigkeit, Tastschreiben, Blindschreiben',
    },
    {
      name: 'author',
      content: '10-Finger-Schreiben-Lernen.de',
    },
  ],
};

// Helper function to generate page-specific SEO
export const getPageSeo = (page) => {
  const seoConfigs = {
    home: {
      title: '10-Finger-Schreiben lernen | Der kostenlose Online-Kurs',
      description: 'Lerne schnell und effizient das 10-Finger-System mit unserem kostenlosen Online-Kurs. Verbessere deine Tippgeschwindigkeit und reduziere Fehler.',
      canonical: 'https://10-finger-schreiben-lernen.de/',
    },
    tipptest: {
      title: 'Kostenloser Tipptest | Teste deine Tippgeschwindigkeit',
      description: 'Teste deine Tippgeschwindigkeit mit unserem kostenlosen Online-Tipptest. Erhalte sofortige Ergebnisse und verfolge deinen Fortschritt.',
      canonical: 'https://10-finger-schreiben-lernen.de/tipptest',
    },
    uebungen: {
      title: 'Übungen zum 10-Finger-Schreiben | Verbessere deine Fähigkeiten',
      description: 'Praktische Übungen zum 10-Finger-Schreiben für Anfänger und Fortgeschrittene. Verbessere deine Tippfähigkeiten mit unseren interaktiven Lektionen.',
      canonical: 'https://10-finger-schreiben-lernen.de/uebungen',
    },
    einfuehrung: {
      title: 'Einführung ins 10-Finger-System | Grundlagen lernen',
      description: 'Lerne die Grundlagen des 10-Finger-Systems. Eine umfassende Einführung für Anfänger mit praktischen Tipps und Übungen.',
      canonical: 'https://10-finger-schreiben-lernen.de/einfuehrung',
    },
    leaderboard: {
      title: 'Leaderboard | Die schnellsten Tipper',
      description: 'Sieh dir an, wie du im Vergleich zu anderen Tippern abschneidest. Unser Leaderboard zeigt die besten Ergebnisse und Fortschritte.',
      canonical: 'https://10-finger-schreiben-lernen.de/leaderboard',
    },
    statistik: {
      title: 'Deine Tipp-Statistiken | Fortschritt verfolgen',
      description: 'Verfolge deinen Fortschritt mit detaillierten Statistiken zu deiner Tippgeschwindigkeit, Genauigkeit und Verbesserung über Zeit.',
      canonical: 'https://10-finger-schreiben-lernen.de/statistik',
    },
    pro: {
      title: 'Pro-Version | Erweiterte Funktionen freischalten',
      description: 'Entdecke die Vorteile unserer Pro-Version. Erhalte Zugang zu erweiterten Übungen, detaillierten Statistiken und personalisierten Lernplänen.',
      canonical: 'https://10-finger-schreiben-lernen.de/pro',
    },
    blog: {
      title: 'Blog | Tipps und Tricks zum 10-Finger-Schreiben',
      description: 'Hilfreiche Artikel, Tipps und Tricks rund ums 10-Finger-System. Verbessere deine Technik mit unseren Expertentipps.',
      canonical: 'https://10-finger-schreiben-lernen.de/blog',
    },
    login: {
      title: 'Login | Zugang zu deinem Konto',
      description: 'Melde dich an, um auf dein Konto zuzugreifen. Verfolge deinen Fortschritt und setze deine Übungen fort.',
      canonical: 'https://10-finger-schreiben-lernen.de/login',
    },
    register: {
      title: 'Registrieren | Kostenloses Konto erstellen',
      description: 'Erstelle ein kostenloses Konto, um deinen Fortschritt zu speichern und alle Funktionen unserer Plattform zu nutzen.',
      canonical: 'https://10-finger-schreiben-lernen.de/register',
    },
  };

  return seoConfigs[page] || {};
};

// Helper function for blog post SEO
export const getBlogPostSeo = (post) => {
  const blogPosts = {
    'tipps-tippgeschwindigkeit-steigern': {
      title: 'Tipps zur Steigerung deiner Tippgeschwindigkeit',
      description: 'Praktische Tipps und Übungen, um deine Tippgeschwindigkeit zu steigern. Lerne, wie du effizienter und schneller tippen kannst.',
      canonical: 'https://10-finger-schreiben-lernen.de/blog/tipps-tippgeschwindigkeit-steigern',
    },
    'vorteile-10-finger-system': {
      title: 'Die Vorteile des 10-Finger-Systems',
      description: 'Erfahre, warum das 10-Finger-System so effektiv ist und welche Vorteile es dir im Alltag und Beruf bringen kann.',
      canonical: 'https://10-finger-schreiben-lernen.de/blog/vorteile-10-finger-system',
    },
    'haeufigste-fehler-vermeiden': {
      title: 'Die häufigsten Fehler beim Tippen vermeiden',
      description: 'Lerne, wie du die häufigsten Fehler beim Tippen erkennen und vermeiden kannst, um deine Effizienz und Genauigkeit zu verbessern.',
      canonical: 'https://10-finger-schreiben-lernen.de/blog/haeufigste-fehler-vermeiden',
    },
  };

  return blogPosts[post] || {};
};